import { Col, Modal, Row } from "antd";
import React from "react";
import { TimesheetActionButtonCol } from "../TimesheetActionButtonCol/TimesheetActionButtonCol";
import { TIME_SHEET_PENDING_ACTION } from "../../TimeSheetConstants";
import "./TimesheetConfirmationModal.css";
const TimesheetConfirmationModal = ({
  open,
  title = "Approve/Reject Timesheet",
  mainHeading = "Are you sure you want to approve or reject the timesheet?",
  subHeading = "*Remember, once the action taken, cannot be reverted back.",
  handleCancel,
  handleApprove,
  handleReject,
  loading=false,
  okButtonText,
  cancelButtonText
}) => {
  return (
    <Modal
      closable={true}
      title={<span className="title-default">{title}</span>}
      width={430}
      footer={
      <div style={{ height: '40px', borderTop: 'none' }}> 
          <TimesheetActionButtonCol
            status={TIME_SHEET_PENDING_ACTION}
            handleApprove={handleApprove}
            handleReject={handleReject}
            loading={loading}
            okButtonText={okButtonText}
            cancelButtonText={cancelButtonText}
          />
        </div>
      }
      open={open}
      onCancel={handleCancel}
    >
      <div style={{ maxHeight: "300px", overflowY: "auto" }}>
        <Row>
          <Col span={24}>
            <Row>
              <p className="confirmation-modal-first-text">{mainHeading}</p>
            </Row>
            <Row>
              <p className="confirmation-modal-sub-text">{subHeading}</p>
            </Row>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export { TimesheetConfirmationModal };
